<script>
    import _            from 'lodash'
    import { onMount }  from 'svelte'
    import * as api     from '../../shared/api.js'
    import AppLoader    from '../../shared/Loader.svelte'    
    import SectionTitle from '../../shared/SectionTitle.svelte'
    import UserItem     from './UserItem.svelte'

    export let _company = null
    export let location = null

    let active    = -1
    let buffer    = []
    let loading   = true
    let working   = false
    let error     = false
    let archetype = empty()

    onMount(() => {
        error = false
        api
            .get("/account/users")
            .then(api.toJsonIf200)
            .then(json => {
                loading = false
                buffer = sorted(json.filter(it => it.type !== 'synthetic'))
            })
            .catch(err => {
                error = true
            })
    })

    function sorted(array) {
        return _.sortBy(array, i => i.name)
    }

    function empty() {
        return { id: 0, name: null, email: null }
    }

    function updateBufferWith(it, add) {
        const remaining = buffer.filter(i => i.id !== it.id)
        console.log(it, remaining)
        if(add) {
            return sorted([...remaining, it])
        } else {
            return sorted(remaining)
        }
    }

    function onUpdate(it) {
        working = true
        const method = it.id > 0 ? 'update' : 'create'
        return api
            .post(`/account/user/${method}`, it)
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                active  = -1
                buffer = updateBufferWith(json, true)
                if(it.id === 0) {
                    archetype = empty()
                }
                return Promise.resolve(true)
            })
            .catch(err => {
                working = false
                return Promise.reject("erro adicionando usuário")
            })
    }

    function onRemove(it) {
        return api
            .del(`/user/${it.id}`)
            .then(res => {
                if(res.status === 200) {
                    buffer = updateBufferWith(it, false)
                    return Promise.resolve(true)
                } else {
                    return Promise.reject("erro removendo usuário")    
                }
            })
            .then(err => {
                return Promise.reject("erro removendo usuário")
            })
    }

</script>

<svelte:head>
	<title>Dogma / Usuários</title>
</svelte:head>

{#if loading || error}
    <AppLoader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>Usuários</SectionTitle>
    <div class="ui raised segments">
        <UserItem 
            bind:active={active} 
            bind:item={archetype} 
            {onUpdate}
            withHeader={false}
        />
        {#each buffer as item (item.id)}
            <UserItem 
                bind:active={active} 
                bind:item={item} 
                {onUpdate} 
                {onRemove} 
            />
        {/each}
    </div>    
{/if}
